module.exports = __webpack_public_path__ + "img/icon-hourglass-line-new.c26fa14.svg";